module.exports = __webpack_public_path__ + "static/media/faqBalance-es-fa.0d7f2b51.vtt";